module.exports = {
  errors: require('./errors'),
  respCodes: require('./respCodes'),
  accountType: require('./accountType'),
  dictOperationReason: require('./dictOperationReason'),
  personType: require('./personType'),
  keyType: require('./keyType'),
  claimType: require('./claimType'),
  claimStatus: require('./claimStatus'),
  qrcodeType: require('./qrcodeType'),
  qrcodeStatus: require('./qrcodeStatus'),
  qrcodeValueModes: require('./qrcodeValueModes'),
  refundStatus: require('./refundStatus'),
  cidFileStatus: require('./cidFileStatus'),
  withdrawAgentMode: require('./withdrawAgentMode'),
  refundNature: require('./refundNature')
};
